/* eslint-disable parog-web/no-glint-expect-error-directive */
import type Owner from '@ember/owner';
import type { EmberChangeset } from 'ember-changeset';
import { runTask } from 'ember-lifeline';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';
import FeelingEvasSectionContent from 'parog-web/components/feeling-evas/sliders/component';
import fuiSlider from 'wise-fui-modules/modifiers/fui-slider';

interface Signature {
  Args: {
    key: string;
    form: WrFormComponentSignature<
      EmberChangeset,
      unknown
    >['Blocks']['default'][0];
  };
  Element: HTMLDivElement;
}

export default class MiciBaseEditionFormSliderComponent extends FeelingEvasSectionContent<Signature> {
  get value(): string {
    return this.args.form.data?.get(this.args.key);
  }

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);
    runTask(this, () => {
      if (!this.args.form.data?.get(this.args.key)) {
        this.args.form.data?.set(this.args.key, '0');
      }
    });
  }

  onChange = (value: number) => {
    this.args.form.data?.set(this.args.key, value.toString());
  };

  <template>
    <div class='flex flex-col gap-8'>
      {{! @glint-expect-error }}
      {{yield to='header'}}

      {{! prettier-ignore }}
      <div data-test-slider={{@key}}>
        <div
          class='ui labeled ticked primary slider'
          ...attributes
          {{fuiSlider min=0 max=10 step=1 start=this.value onChange=this.onChange autoAdjustLabels=false }}
        ></div>

        <div class='flex justify-between'>
          <span class='ui small text-black'>
            {{! @glint-expect-error }}
            {{yield to='lowest'}}
          </span>
          <span class='ui small text-right text-black'>
            {{! @glint-expect-error }}
            {{yield to='highest' }}
          </span>
        </div>
      </div>
      <div class='mb-4'>
        Ressenti actuel :
        {{this.value}}
      </div>
    </div>
  </template>
}
